export default __webpack_public_path__ + "static/media/soundcloud.f2876294.svg";